import { render, staticRenderFns } from "./newJoin_next.vue?vue&type=template&id=56539fc6&scoped=true&"
import script from "./newJoin_next.vue?vue&type=script&lang=js&"
export * from "./newJoin_next.vue?vue&type=script&lang=js&"
import style0 from "./newJoin_next.vue?vue&type=style&index=0&id=56539fc6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56539fc6",
  null
  
)

export default component.exports